export default {
  routeExtras: {
    'extras': 'Opzioni extra per il percorso',
    'extraInfo': 'Informazioni extra',
    'value': 'Valore',
    'clickToHighlightOnMap': 'Clicca per evidenziare sulla mappa',
    'showAllOnMap': 'Mostra tutto sulla mappa'
  }
}
